import { render, staticRenderFns } from "./WheelsCheckbox.vue?vue&type=template&id=fd08e098"
import script from "./WheelsCheckbox.vue?vue&type=script&lang=js"
export * from "./WheelsCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports